import { ProgramIntakeFormFields } from '../components/IntakeFormActions';

export type ChangedIntakeFields = Record<string, string | number>;

function toDateOnly(isoString: string): string {
  if (!isoString) return '';
  return isoString.split('T')[0];
}

function parseApplicationFee(value: string): number {
  if (!value) {
    return 0;
  }

  const normalized = value
    .replace(/[^0-9.,-]/g, '')
    .replace(/,/g, '')
    .trim();

  const validNumberPattern = /^-?\d+(?:\.\d+)?$/;
  if (!validNumberPattern.test(normalized)) {
    return 0;
  }

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function getChangedIntakeFields(
  values: ProgramIntakeFormFields,
  defaultValues: ProgramIntakeFormFields
): ChangedIntakeFields {
  const changedFields: ChangedIntakeFields = {};

  if (toDateOnly(values.firstDayOfClass) !== toDateOnly(defaultValues.firstDayOfClass)) {
    changedFields.firstDayOfClassOn = toDateOnly(values.firstDayOfClass);
  }

  if (toDateOnly(values.lastDayOfClass) !== toDateOnly(defaultValues.lastDayOfClass)) {
    changedFields.lastDayOfClassOn = toDateOnly(values.lastDayOfClass);
  }

  if (values.acceptingApplicationsStartsAt !== defaultValues.acceptingApplicationsStartsAt) {
    changedFields.acceptingAppsStartsAt = values.acceptingApplicationsStartsAt;
  }

  if (values.acceptingApplicationsStopsAt !== defaultValues.acceptingApplicationsStopsAt) {
    changedFields.acceptingAppsClosesAt = values.acceptingApplicationsStopsAt;
  }

  if (values.refundDeadlineAt !== defaultValues.refundDeadlineAt) {
    changedFields.refundDeadlineAt = values.refundDeadlineAt;
  }

  if (values.deferralDeadlineAt !== defaultValues.deferralDeadlineAt) {
    changedFields.deferralDeadlineAt = values.deferralDeadlineAt;
  }

  if (values.applicationFee !== defaultValues.applicationFee) {
    changedFields.applicationFee = parseApplicationFee(values.applicationFee);
  }

  return changedFields;
}
